import(/* webpackMode: "eager" */ "/codebuild/output/src1662968122/src/bluberries-dash/src/app/page.tsx");
